/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { AlarmPulseLoader, useAppDispatch, useAppSelector } from '../../globalUtils/globalExports'
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { getCurrentFiltersValues, getDashboardReducer, setRedirectedStateForAlarmFilters, fetchOldFirmwareList, setFilterData, getReferenceDataReducer, getFilterSelectedValue} from '../../rmsReduxStore/reduxExports';
import './Overview.css';
import { IconWithTooltip } from '../../globalUtils/globalIcons';
import { useNavigate } from 'react-router-dom';
import { setRedirectedStateForChargerFilters } from '../../rmsReduxStore/chargersRedux/chargerCreators';
import * as d3 from 'd3';
import { formatNumberWithCommas, useEffectOnce } from '../../globalUtils/globalHooks';

interface OverViewProps {
    handleFilter: Function,
    handleOfflineClick: Function,
    getFilterValue: Function
}

const Overview: FC<OverViewProps> = (props) => {
    const { handleFilter, getFilterValue, handleOfflineClick } = props;
    const navigate = useNavigate();
    const { newDashboardRealTimeGunsInfo,newDashboardConnectivityMediumData } = useAppSelector(getDashboardReducer);
    const {customerReferenceData} = useAppSelector(getReferenceDataReducer);
    const dispatch = useAppDispatch();
    const isLoading = !newDashboardRealTimeGunsInfo || !newDashboardConnectivityMediumData;
    const [isLabelStruck, setIsLabelStruck] = useState<boolean>(false);

    useEffectOnce(() => {
        const offlineFilter = getFilterValue('offlineFiveDays');
        
        if(offlineFilter?.[0]?.id == 'true') setIsLabelStruck(true);
        else                             setIsLabelStruck(false);
    })

    // const createGaugeOptions = (value: number, label: string) => ({
    //     chart: {
    //         type: 'solidgauge',
    //         height: '110%',
    //         backgroundColor: 'transparent',
    //     },
    //     title: null,
    //     pane: {
    //         center: ['50%', '50%'],
    //         size: '100%',
    //         startAngle: -90,
    //         endAngle: 90,
    //         border:0,
    //         background: {
    //             backgroundColor: '#EEE',
    //             borderWidth:0,
    //             innerRadius: '60%',
    //             outerRadius: '100%',
    //             shape: 'arc',
    //         },
    //     },
    //     tooltip: { enabled: false },
    //     exporting: { enabled: false },
    //     yAxis: {
    //         min: 0,
    //         max: 100,
    //         lineWidth: 0,
    //         tickPositions: [],
    //         labels: { enabled: false },
    //     },
    //     plotOptions: {
    //         solidgauge: {
    //             borderWidth: 0,
    //             borderColor: 'transparent',
    //             dataLabels: {
    //                 y: -37,
    //                 borderWidth: 0,
    //                 useHTML: true,
    //                 format: `
    //         <div style="text-align:center">
    //             <span style="font-size:12px;color:#333">{y}%</span><br/>
    //             <span style="font-size:11px;color:#666; font-weight:400">${label}</span>
    //         </div>
    //         `
    //             }
    //         }
    //     },
    //     series: [
    //         {
    //             name: label,
    //             data: [{
    //                 y: value,
    //                 color: {
    //                     linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
    //                     stops: [
    //                         [0.0, '#F3D97F'],   // Yellow
    //                         [0.5, '#78C4A0'],   // Green
    //                         [1.0, '#53B9CD'],   // Blue
    //                     ]
    //                 },
    //                 radius: '100%',
    //                 innerRadius: '60%', 
    //             }],
    //             dataLabels: {
    //                 enabled: true
    //             }
    //         }
    //     ],
    //     credits: { enabled: false }
    // });

    const handleChargerOfflineClick = async () => {
        const valueToSend = !isLabelStruck;
        setIsLabelStruck(prev => !prev)
        const filterObject = [{
            id: valueToSend.toString(),
            value: valueToSend.toString(),
            label: valueToSend.toString(),
            name: valueToSend.toString()
        }]

        const filters = await setFilterData(filterObject, 'offlineFiveDays', 'dashboardV2', 'SET', false)(dispatch) //offlinefilter
        handleOfflineClick(filters);
    }

    const mapToRange = (x: number): number => {
        const minOutput = 3;
        const maxOutput = 100;
        return minOutput + (x / 100) * (maxOutput - minOutput);
    }
    
    const connectivitySeries = useMemo(() => {
        const data = newDashboardConnectivityMediumData ? [...newDashboardConnectivityMediumData] : [];
        const colorArr: string[] = ['#9FEEEE', '#65DADA', '#06BFBF'];

        const isDisabledData = data.length === 0 || (
            data.length === 1 &&
            data[0].count === 0 &&
            data[0].percentage === 0
        );

        if (isDisabledData) {
            return [{
                name: 'Disabled',
                data: [{ y: 100 }],
                color: '#e0e0e0',
                stack: 'connectivity',
                enableMouseTracking: false,
                showInLegend: false
            }];
        }

        return data?.sort((a, b) => b?.percentage - a?.percentage)?.map((item, ind) => ({
            name: item.network,
            data: [{
                y: mapToRange(item.percentage || 0),
                custom: {
                    count: item.count,
                    network: item.network,
                    percentage: item.percentage,
                }
            }],
            color: colorArr?.length > ind ? colorArr[ind] : '#ccc',
            stack: 'connectivity'
        })) || [];

    }, [newDashboardConnectivityMediumData])

    const isDisabledOnly = connectivitySeries.length === 1 && connectivitySeries[0].name === 'Disabled';

    const connectivityChartOptions = {
        chart: {
            type: 'column',
            height: 200,
            width: isDisabledOnly ? 120 : 180,
            backgroundColor: 'transparent',
            spacingBottom: 5,
            spacingLeft: 0,
        },
        title: { text: null },
        exporting: { enabled: false },
        xAxis: { 
            categories: [''],
            visible: false,
            minPadding: 0.5
        },
        yAxis: {
            visible: false,
            min: 0,
            max: 100,
            reversedStacks: false,
        },
        tooltip: { enabled: false },
        legend: { enabled: false },
        plotOptions: {
            column: {
                borderRadius : 6,
                pointPlacement: -0.4,
                stacking: 'percent',
                borderWidth: 2,
                pointPadding: 0,
                groupPadding: 0,
                pointWidth: 35,
                dataLabels: {
                    borderRadius: 0 ,
                    enabled: true,
                    useHTML: true,
                    inside: true,
                    align: 'left',
                    verticalAlign: 'middle',
                    x: 35,
                    crop: false,
                    overflow: 'none',
                    allowOverlap: true,
                    formatter: function (this: Highcharts.Point) {
                        const point = (this as any).point || this;
                        const count = point?.custom?.count ?? 0;
                        const network = this.series.name;
                        const percentage = (this as any)?.point?.custom?.percentage?.toFixed(2) ?? '0.0';
                        if(isDisabledOnly) return ''
                        const seriesCount = this.series.chart.series.length;
                        const isLast = this.series.index === seriesCount - 1;
                        const verticalOffset = isLast ? '-4px' : '2px';
                        
                        return `
                        <div style="
                          display: flex;
                          align-items: center;
                          gap: 6px;
                          font-size: 10px;
                          font-weight: 300;
                          color: #515763;
                          transform: translateY(${verticalOffset});
                        ">
                          <div style="
                            position: relative;
                            display: inline-block;
                          ">
                            <div style="
                              background: #1E1E1E;
                              color: #fff;
                              font-size: 10px;
                              padding: 2px 6px;
                              border-radius: 4px;
                              height: 16px;
                              display: inline-block;
                              position: relative;
                              font-weight: 400;
                            ">
                              ${count}
                            </div>
                            <div style="
                              position: absolute;
                              right: 100%;
                              top: 50%;
                              transform: translateY(-50%);
                              width: 0;
                              height: 0;
                              border-top: 3px solid transparent;
                              border-bottom: 3px solid transparent;
                              border-right: 6px solid #1E1E1E;
                            "></div>
                          </div>
                          <div>
                            <span style="color: #000;">${network}</span> 
                            <span style="color: #000; font-weight: 500"><b>(${percentage}%)</b></span>
                          </div>
                        </div>
                      `;                    
                    }                 
                }
            },
        },
        series:connectivitySeries,
        credits: { enabled: false },
    };

    // const utilizationOptions = createGaugeOptions(Math.round(newDashboardRealTimeGunsInfo?.onlinePercentage ?? 0), 'Online');
    // const uptimeOptions = createGaugeOptions(Math.round(newDashboardRealTimeGunsInfo?.healthyPercentage ?? 0), 'Healthy');
    const customersToInclude = customerReferenceData?.filter(customer=> customer?.customerType==='External' &&  customer?.name!=='All')?.map(customer=>({
        id: customer?.id,
        value: customer?.value,
        label: customer?.label,
        name: customer?.name
     }))
    const handleOldFirmwareClick = async () => {
        const newDashboardFilters = getCurrentFiltersValues('dashboardV2')?.filter((filter) => filter.key === 'productType' || filter.key === 'customer');
        const res = await dispatch(fetchOldFirmwareList({filters: newDashboardFilters}));
        // const res = {
        //     'success': true,
        //     'oldFirmware': [
        //         {
        //         'productType': 'EVM150',
        //         'softwareVersions': [
        //             '42.12.21.05'
        //         ]
        //         }
        //     ]
        // }
        const firmwareList = (res?.data?.oldFirmware || []).flatMap((item: any) => Array.isArray(item.softwareVersions) ? item.softwareVersions : [])?.map(version => ({
            id: version,
            value: version,
            label: version,
            name: version
        })) || [];
        
        if(firmwareList && firmwareList.length > 0) {
            const customerFilterValue = await getFilterSelectedValue('customer','global',true);
            await setFilterData(null, '', 'chargers', 'CLEAR', false)(dispatch);
            await setFilterData(firmwareList, 'softwareVersion', 'chargers', 'SET', false)(dispatch)
            const customerFilter = customerFilterValue && customerFilterValue?.length > 0 ? customerFilterValue : customersToInclude;
            await setRedirectedStateForChargerFilters(true, null, null, null, 'newDashboard',customerFilter)(dispatch);
            navigate('/manage-chargers')
        }
    }

    return (
        <div className="widget-wrap new-dashboard-overview">
            {/* <div className="new-dashboard-overview-container"> */}
                <div className="widget-header new-dashboard-overview-container-header">
                    <div className="new-dashboard-overview-container-header-left">
                        <div className="widget-heading new-dashboard-overview-gauge-label">
                            Overview
                            <IconWithTooltip iconClassName="info-icon" toolTipText={'An overview of charger status, gun status, internet connectivity, etc.'} containerClassName={'new-dashboard-widget-header-tooltip'} />
                        </div>
                        {/* <span className="new-dashboard-overview-gauge-sub">An Overview of charger status, gun status, internet connectivity, etc. </span> */}
                        
                    </div>
                </div>
                <div className='widget-body new-dashboard-overview-container-body'>
                    <div className={`overview__blur-content ${isLoading ? 'blurred' : ''}`}>
                        <div className="gauge">
                            {/* <HighchartsReact highcharts={Highcharts} options={utilizationOptions} />
                            <HighchartsReact highcharts={Highcharts} options={uptimeOptions} /> */}
                            <CustomGauge value={newDashboardRealTimeGunsInfo?.onlinePercentage ?? 0} width={150} label={'Online'} />
                            <CustomGauge value={newDashboardRealTimeGunsInfo?.healthyPercentage ?? 0} width={150} label={'Healthy'} />
                        </div>
                        <div className="metrics">
                        <div className="metrics-grp-a">
                            <div className="metric green" >
                                <span className="cursor-pointer"
                                    onClick={async () => {
                                        const customerFilterValue = await getFilterSelectedValue('customer','global',true);
                                        await setFilterData(null, '', 'chargers', 'CLEAR', false)(dispatch);
                                        const customerFilter = customerFilterValue && customerFilterValue?.length > 0 ? customerFilterValue : customersToInclude;
                                        setRedirectedStateForChargerFilters(true, 'Healthy', null, null, 'newDashboard',customerFilter)(dispatch).then(res => {
                                        if (res === 'Action dispatched successfully') {
                                            navigate('/manage-chargers', {
                                            state: { chargerStatusId: 'Healthy' }
                                            });
                                        }
                                        });
                                    }}
                                >{formatNumberWithCommas(newDashboardRealTimeGunsInfo?.healthyChargers) || 0}</span>
                                <div className="metric-subHeading">Healthy Chargers</div>
                            </div>

                            <div className="metric green" >
                                <span
                                    // onClick={() => {
                                    //     setRedirectedStateForAlarmFilters(true, null, 'CMS Comm Fail', null)(dispatch).then(res => {
                                    //     if (res === 'Action dispatched successfully') {
                                    //         navigate('/alarms', {
                                    //         state: { alarmType: 'CMS Comm Fail' }
                                    //         });
                                    //     }
                                    //     });
                                    // }}
                                >{formatNumberWithCommas(newDashboardRealTimeGunsInfo?.cmsConnectivity) || 0}</span>
                                <div className="metric-subHeading">CMS Connectivity</div>
                            </div>

                            <div
                            className="metric blue"
                            // onClick={() => {
                            //     setRedirectedStateForChargerFilters(false, 'Occupied', null, null, 'newDashboard')(dispatch).then(res => {
                            //     if (res === 'Action dispatched successfully') {
                            //         navigate('/manage-chargers', {
                            //         state: { chargerStatusId: 'Occupied' }
                            //         });
                            //     }
                            //     });
                            // }}
                            >
                            <span>{formatNumberWithCommas(newDashboardRealTimeGunsInfo?.occupiedGuns) || 0}</span>
                            <div className="metric-subHeading">Occupied Guns</div>
                            </div>


                        </div>

                        <div className="metrics-grp-b">
                            <div className="metric blue">
                                <span 
                                    // onClick={() => {
                                    //     setRedirectedStateForChargerFilters(false, 'Operable', null, null, 'newDashboard')(dispatch).then(res => {
                                    //     if (res === 'Action dispatched successfully') {
                                    //         navigate('/manage-chargers', {
                                    //         state: { chargerStatusId: 'Operable' }
                                    //         });
                                    //     }
                                    //     });
                                    // }}
                                >{formatNumberWithCommas(newDashboardRealTimeGunsInfo?.operable) || 0}</span>
                                <div className="metric-subHeading">Operational Guns</div>
                            </div>
                            <div className="metric orange">
                            <span className={'cursor-pointer'}
                                onClick={() => {
                                    handleOldFirmwareClick()
                                }}
                            >{formatNumberWithCommas(newDashboardRealTimeGunsInfo?.oldFirmware) || 0}</span>
                            <div className="metric-subHeading">Old Firmware</div>
                            </div>

                            <div className="metric orange">
                                <span className="cursor-pointer"
                                    onClick={async () => {
                                        const customerFilterValue = await getFilterSelectedValue('customer','',true);
                                        await setFilterData(null, '', 'alarms', 'CLEAR', false)(dispatch);
                                        const customerFilter = customerFilterValue && customerFilterValue?.length > 0 ? customerFilterValue : customersToInclude;
                                        setRedirectedStateForAlarmFilters(true, null, 'CMS Comm Fail', null,'Online',customerFilter)(dispatch).then(res => {
                                        if (res === 'Action dispatched successfully') {
                                            navigate('/alarms', {
                                            state: { alarmType: 'CMS Comm Fail' }
                                            });
                                        }
                                        });
                                    }}
                                >{formatNumberWithCommas(newDashboardRealTimeGunsInfo?.cmsOfflineCharger) || 0}</span>
                                <div className="metric-subHeading">CMS Offline</div>
                            </div>
                        </div>
                        <div className="metrics-grp-c">

                            <div className="metric orange">
                                <span className="cursor-pointer"
                                    onClick={async () => {
                                        const customerFilterValue = await getFilterSelectedValue('customer','',true);
                                        await setFilterData(null, '', 'chargers', 'CLEAR', false)(dispatch);
                                        const customerFilter = customerFilterValue && customerFilterValue?.length > 0 ? customerFilterValue : customersToInclude;
                                        setRedirectedStateForChargerFilters(true, 'Faulty', null, null, 'newDashboard',customerFilter)(dispatch).then(res => {
                                        if (res === 'Action dispatched successfully') {
                                            navigate('/manage-chargers', {
                                            state: { chargerStatusId: 'Faulty' }
                                            });
                                        }
                                        });
                                    }}
                                >{formatNumberWithCommas(newDashboardRealTimeGunsInfo?.faultyChargers) || 0}</span>
                                <div className="metric-subHeading">Faulty Chargers</div>
                            </div>

                            <div className="metric orange" >
                                <span
                                    // onClick={() => {
                                    //     setRedirectedStateForChargerFilters(false, 'Not Operable', null, null, 'newDashboard')(dispatch).then(res => {
                                    //     if (res === 'Action dispatched successfully') {
                                    //         navigate('/manage-chargers', {
                                    //         state: { chargerStatusId: 'Not Operable' }
                                    //         });
                                    //     }
                                    //     });
                                    // }}
                                >{formatNumberWithCommas(newDashboardRealTimeGunsInfo?.notOperable) || 0}</span>
                                <div className="metric-subHeading">Non-Operational Guns</div>
                            </div>
                            <div className={`metric orange ${isLabelStruck ? 'dimmed-tile' : ''}`}>
                                <span
                                    className={`cursor-pointer ${isLabelStruck ? 'greyed-value' : ''}`}
                                    onClick={async () => {
                                        if (isLabelStruck) return; 
                                        const customerFilterValue = await getFilterSelectedValue('customer','',true);
                                        await setFilterData(null, '', 'chargers', 'CLEAR', false)(dispatch);  
                                        const customerFilter = customerFilterValue && customerFilterValue?.length > 0 ? customerFilterValue : customersToInclude;   
                                    setRedirectedStateForChargerFilters(true, 'OfflinMoreThan5Days', null, null, 'newDashboard',customerFilter)(dispatch).then(res => {
                                        if (res === 'Action dispatched successfully') {
                                        navigate('/manage-chargers', {
                                            state: { chargerStatusId: 'OfflinMoreThan5Days' }
                                        });
                                        }
                                    });
                                    }}
                                >
                                    {formatNumberWithCommas(newDashboardRealTimeGunsInfo?.offlineChargersMoreThan5Days) || 0}
                                </span>
                                <div
                                    className={`metric-subHeading offline-wrap ${isLabelStruck ? 'struck-label' : 'cursor-pointer'}`}
                                    onClick={() => handleChargerOfflineClick()}
                                >
                                    <div>Offline &gt; 5 Days</div>
                                    <IconWithTooltip
                                    iconClassName="info-icon"
                                    containerClassName="metric-subheading-tooltip-wrap"
                                    toolTipText="Click to disable/enable offline chargers"
                                    />
                                </div>
                            </div>
                        </div>
                        </div>

                        <div className="rms_connectivity_graph_container">
                            <div className="rms_connectivity_graph_container_body">
                                <HighchartsReact highcharts={Highcharts} options={connectivityChartOptions} />
                            </div>
                            <div className='rms_connectivity_graph_container_bottom_heading'>
                            Medium Connectivity <span className="highlight-text">({newDashboardRealTimeGunsInfo?.onlineChargers} Online)</span>
                            </div>
                        </div>
                    </div>
                    {isLoading && (
                        <div className="overview__blur-overlay">
                            <div className="loader-wrapper">
                                <AlarmPulseLoader showLoader={isLoading} />
                            </div>
                        </div>
                    )}
                </div>
            {/* </div> */}
        </div>
    );   
}

export default Overview

interface CustomGaugeProps {
    value: number,
    width: number, 
    label: string
}

const CustomGauge: FC<CustomGaugeProps> = ({ value, width, label }) => {
    const svgRef = useRef<SVGSVGElement>(null);

    useEffect(() => {
        const height = width * 0.5;
        const outerRadius = width * 0.47;
        const innerRadius = width * 0.41;
        const centerWhiteRadius = width * 0.24;
        const knobRadius = (outerRadius + innerRadius) / 2;
        const piValue = (Math.PI/2);

        const angle = -Math.PI + (value / 100) * Math.PI;

        const svg = d3.select(svgRef.current);
        svg.selectAll('*').remove();

        const g = svg
            .attr('width', width)
            .attr('height', height+10)
            .append('g')
            .attr('transform', `translate(${width / 2}, ${height})`);

        // Gradient defs
        const defs = svg.append('defs');
        const gradient = defs.append('linearGradient')
            .attr('id', 'gradient')
            .attr('gradientUnits', 'userSpaceOnUse')
            .attr('x1', -outerRadius).attr('y1', 0)
            .attr('x2', outerRadius).attr('y2', 0);

        gradient.append('stop').attr('offset', '0%').attr('stop-color', '#E80D5B');
        gradient.append('stop').attr('offset', '8%').attr('stop-color', '#FC7748');
        gradient.append('stop').attr('offset', '17%').attr('stop-color', '#FF8744');
        gradient.append('stop').attr('offset', '30%').attr('stop-color', '#FFC251');
        gradient.append('stop').attr('offset', '60%').attr('stop-color', '#8DC63F');
        gradient.append('stop').attr('offset', '85%').attr('stop-color', '#148554');
        gradient.append('stop').attr('offset', '100%').attr('stop-color','#0B8D55');

        const greyGradient = defs.append('linearGradient')
            .attr('id', 'greyGradient')
            .attr('gradientUnits', 'userSpaceOnUse')
            .attr('x1', -innerRadius).attr('y1', '0%')
            .attr('x2', innerRadius).attr('y2', '0%');

        greyGradient.append('stop').attr('offset', '10%').attr('stop-color', '#FFF');
        greyGradient.append('stop').attr('offset', '30%').attr('stop-color', '#EAEAEA');
        greyGradient.append('stop').attr('offset', '50%').attr('stop-color', '#E8E8E8');
        greyGradient.append('stop').attr('offset', '70%').attr('stop-color', '#EAEAEA');
        greyGradient.append('stop').attr('offset', '90%').attr('stop-color', '#FFF');

        // Inner grey arc
        const innerArc = d3.arc()
            .innerRadius(innerRadius - width * 0.16)
            .outerRadius(innerRadius - width * 0.01)
            .startAngle(-piValue - 0.01)
            .endAngle(piValue + 0.01);

        g.append('path')
            .attr('d', innerArc as any)
            .attr('fill', 'url(#greyGradient)');

        // Background arc
        const arc = d3.arc()
            .innerRadius(innerRadius)
            .outerRadius(outerRadius)
            .startAngle(-piValue)
            .endAngle(piValue)
            .cornerRadius((outerRadius - innerRadius) / 2);

        g.append('path')
            .attr('d', arc as any)
            .attr('fill', '#eee');

        // Filled arc
        const filledArc = d3.arc()
            .innerRadius(innerRadius)
            .outerRadius(outerRadius)
            .startAngle(-piValue-0.05)
            .endAngle(piValue+0.05)
            .cornerRadius((outerRadius - innerRadius) / 2);

        g.append('path')
            .attr('d', filledArc as any)
            .attr('fill', 'url(#gradient)');

        // Dashed needle
        const needleStart = innerRadius - width * 0.16;
        const needleEnd = innerRadius - width * 0.01;
        const xFinal = Math.cos(angle) * needleEnd;
        const yFinal = Math.sin(angle) * needleEnd;
        const xInitial = Math.cos(angle) * needleStart;
        const yInitial = Math.sin(angle) * needleStart;

        g.append('line')
            .attr('x1', xInitial).attr('y1', yInitial)
            .attr('x2', xFinal).attr('y2', yFinal)
            .attr('stroke', '#999')
            .attr('stroke-dasharray', '4,4')
            .attr('stroke-width', width * 0.008);

        // White mask semicircle
        const maskArc = d3.arc()
            .innerRadius(0)
            .outerRadius(centerWhiteRadius)
            .startAngle(-piValue)
            .endAngle(piValue);

        g.append('path')
            .attr('d', maskArc as any)
            .attr('fill', 'white');

        // Knob circle
        const knobX = Math.cos(angle) * knobRadius;
        const knobY = Math.sin(angle) * knobRadius;

        g.append('circle')
            .attr('cx', knobX)
            .attr('cy', knobY)
            .attr('r', (outerRadius - innerRadius)/2)
            .attr('fill', 'transparent')
            .attr('stroke', 'white')
            .attr('stroke-width', width * 0.015);

        // Center text
        svg.append('text')
            .attr('x', width / 2)
            .attr('y', height - width * 0.11)
            .attr('text-anchor', 'middle')
            .attr('font-size', width * 0.085)
            .attr('font-weight', '400')
            .attr('fill', '#000')
            .text(`${value.toFixed(1)}%`);

        svg.append('text')
            .attr('x', (width / 2) - 4)
            .attr('y', height - width * 0.03)
            .attr('text-anchor', 'middle')
            .attr('font-size', width * 0.058)
            .attr('fill', '#5A5F6F')
            .text(label ?? 'Online');
    }, [value, width, label]);

    return (
        <svg ref={svgRef}></svg>
    );
};
